export const NAV_ITEMS = [
  {
    label: "Birthday Gifts",
    sub: ["Gifts for Him", "Gifts for Her", "Gifts For Kids"],
  },
  {
    label: "Anniversary Gifts",
    sub: ["Gifts for Him", "Gifts for Her", "Gifts for Couple"],
  },
  {
    label: "Gifts by Relationship",
    sub: [
      "Boyfriend", "Girlfriend", "Husband", "Wife",
      "Sister", "Brother", "Friends", "Couple",
      "Father", "Mother", "Fiance", "Kids",
    ],
  },
  {
    label: "Gifts by Type",
    sub: [
      "Romantic", "Quirky", "Naughty", "Nostalgic",
      "Do-it Together", "Comfort & Warmth", "Countdown Surprises",
      "Celebration & Excitement",
    ],
  },
  { label: "Style Your Own", sub: [] },
  {
    label: "Special Days",
    sub: [
      "Holi Gifts", "Diwali Gifts", "Rakhi Gifts",
      "Christmas Gifts", "New Year Gifts", "Valentine's Day",
      "Mother's Day", "Wedding Gifts", "Father's Day",
    ],
  },
  {
    label: "Bulk Gifting",
    sub: ["Corporate Gifting", "Wedding Gifting"],
  },
];

export const HERO_SLIDES = [
  {
    bg: "#FDF3EC",
    tag: "New Collection",
    title: "Gifts That Feel\nLike a Warm Hug",
    subtitle: "Curated hampers for every heart & occasion",
    cta: "Shop Now",
    accent: "#E8735A",
    emoji: "🎁",
  },
  {
    bg: "#EEF4FB",
    tag: "Anniversary Special",
    title: "Love Wrapped\nIn a Box",
    subtitle: "Romantic gift sets handpicked with care",
    cta: "Explore",
    accent: "#4A7FC1",
    emoji: "💝",
  },
  {
    bg: "#F0F8F2",
    tag: "Corporate",
    title: "Bulk Gifting\nMade Effortless",
    subtitle: "Impress clients & teams with curated gifts",
    cta: "Get a Quote",
    accent: "#3A9E6A",
    emoji: "🎊",
  },
];

export const CATEGORIES = [
  { icon: "🎂", label: "Birthday",     color: "#FFE8D6", accent: "#E8735A" },
  { icon: "💑", label: "Anniversary",  color: "#FFE4EE", accent: "#D4538B" },
  { icon: "🌸", label: "Mother's Day", color: "#E8F5E9", accent: "#3A9E6A" },
  { icon: "👨‍👩‍👧", label: "Family",      color: "#E8EEF8", accent: "#4A7FC1" },
  { icon: "💼", label: "Corporate",    color: "#F3EEF8", accent: "#7B5EA7" },
  { icon: "🪔", label: "Festivals",    color: "#FFF8E1", accent: "#F4A800" },
  { icon: "💕", label: "For Her",      color: "#FCE4EC", accent: "#C2185B" },
  { icon: "👔", label: "For Him",      color: "#E3F2FD", accent: "#1565C0" },
];

export const PRODUCTS = [
  {
    id: 1,
    name: "Midnight Luxe Gift Hamper",
    price: 1499, mrp: 1999,
    tag: "Bestseller", tagColor: "#E8735A",
    emoji: "🌙", bg: "#FDF3EC",
    description: "Premium curated hamper with handpicked goodies",
    rating: 4.8, reviews: 312,
    category: "Hampers",
  },
  {
    id: 2,
    name: "Sunset Romance Box",
    price: 1199, mrp: 1599,
    tag: "New", tagColor: "#3A9E6A",
    emoji: "🌅", bg: "#FFF0F5",
    description: "A romantic box filled with love notes & surprises",
    rating: 4.9, reviews: 198,
    category: "New Arrivals",
  },
  {
    id: 3,
    name: "Happy Birthday Surprise",
    price: 899, mrp: 1299,
    tag: "Popular", tagColor: "#4A7FC1",
    emoji: "🎉", bg: "#EEF4FB",
    description: "Celebrate their special day with a bang",
    rating: 4.7, reviews: 543,
    category: "Bestsellers",
  },
  {
    id: 4,
    name: "Cozy Comfort Hamper",
    price: 1349, mrp: 1799,
    tag: "Trending", tagColor: "#7B5EA7",
    emoji: "☕", bg: "#F3EEF8",
    description: "Warmth and care packed into one beautiful box",
    rating: 4.6, reviews: 221,
    category: "Hampers",
  },
  {
    id: 5,
    name: "Anniversary Gold Box",
    price: 1799, mrp: 2499,
    tag: "Bestseller", tagColor: "#E8735A",
    emoji: "💍", bg: "#FFFBEA",
    description: "Mark milestones with something unforgettable",
    rating: 4.9, reviews: 407,
    category: "Bestsellers",
  },
  {
    id: 6,
    name: "Quirky Fun Pack",
    price: 749, mrp: 999,
    tag: "Fun Pick", tagColor: "#D4538B",
    emoji: "🦄", bg: "#FCE4EC",
    description: "For the friend who loves to laugh & surprise",
    rating: 4.5, reviews: 167,
    category: "Under ₹999",
  },
  {
    id: 7,
    name: "Diwali Festive Hamper",
    price: 1599, mrp: 2199,
    tag: "Seasonal", tagColor: "#F4A800",
    emoji: "🪔", bg: "#FFF8E1",
    description: "Light up their lives with this festive delight",
    rating: 4.8, reviews: 289,
    category: "Hampers",
  },
  {
    id: 8,
    name: "Self-Care Goddess Box",
    price: 1099, mrp: 1499,
    tag: "For Her", tagColor: "#C2185B",
    emoji: "🌺", bg: "#FFF0F5",
    description: "Pampering essentials for the queen in your life",
    rating: 4.7, reviews: 334,
    category: "New Arrivals",
  },
];

export const PRODUCT_FILTERS = ["All", "Bestsellers", "New Arrivals", "Under ₹999", "Hampers"];

export const WHY_US = [
  { icon: "🚚", title: "24–48 Hr Delivery",         desc: "Fast and reliable delivery for every special occasion" },
  { icon: "🎁", title: "Free Surprise Gift",         desc: "Every order above 150 AED comes with a complimentary gift from us" },
  { icon: "💝", title: "Premium Gift Packaging",     desc: "Beautifully packed and ready to delight your loved ones" },
  { icon: "📝", title: "Free Personal Message",      desc: "Add your heartfelt note at no extra cost" },
  { icon: "📱", title: "Customer Support 7 Days",    desc: "Friendly assistance whenever you need help" },
];

export const TESTIMONIALS = [
  {
    name: "Sara A.", city: "Dubai, UAE", avatar: "🌸", stars: 5,
    text: "I ordered a gift hamper for my daughter's birthday and she absolutely loved it! Everything was so cute and well-packaged. Moon Berry is my go-to for gifts now!",
  },
  {
    name: "Fatima R.", city: "Abu Dhabi, UAE", avatar: "✨", stars: 5,
    text: "The stationery set I ordered was even more beautiful in person. Super fast delivery to Abu Dhabi and the quality is amazing. Will definitely be ordering again!",
  },
  {
    name: "Layla M.", city: "Sharjah, UAE", avatar: "💜", stars: 5,
    text: "Moon Berry has the most unique and adorable products! I bought keychains and lunch boxes for my kids and they were so happy. Highly recommend to everyone in UAE!",
  },
  {
    name: "Aisha K.", city: "Dubai, UAE", avatar: "🎀", stars: 5,
    text: "Ordered a custom gift hamper for my friend's baby shower and it was perfect. The attention to detail and the cute packaging made it extra special. Thank you Moon Berry!",
  },
];

export const FOOTER_LINKS = [
  {
    title: "Shop",
    links: ["Birthday Gifts", "Anniversary Gifts", "For Her", "For Him", "Corporate Gifting", "Festival Gifts"],
  },
  {
    title: "Occasions",
    links: ["Valentine's Day", "Mother's Day", "Diwali", "Christmas", "Rakhi", "Weddings"],
  },
  {
    title: "Support",
    links: ["Track Your Order", "FAQs", "Shipping Policy", "Return Policy", "Contact Us"],
  },
  {
    title: "Company",
    links: ["About Us", "Blog", "Careers", "Privacy Policy", "Terms of Service"],
  },
];

export const SOCIAL_ICONS = ["📘", "📸", "🐦", "▶️"];
export const PAYMENT_METHODS = ["💳 Visa", "💳 Mastercard", "📱 UPI", "🅿️ PayPal"];
export const TRUST_BADGES = ["🚀 Fast Delivery", "🎁 Free Gift", "⭐ 10K+ Happy Customers"];
export const MARQUEE_TEXT = "🎉 Make your 1st order through WhatsApp — 0567475975 &amp; get 15% OFF &nbsp;&nbsp;&nbsp;&nbsp; 🚚 Free UAE Delivery on Orders above 250 AED via WhatsApp &nbsp;&nbsp;&nbsp;&nbsp;";
